/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetTypeResponse
 */
export interface AssetTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeResponse
     */
    name?: string;
}

/**
 * Check if a given object implements the AssetTypeResponse interface.
 */
export function instanceOfAssetTypeResponse(value: object): value is AssetTypeResponse {
    return true;
}

export function AssetTypeResponseFromJSON(json: any): AssetTypeResponse {
    return AssetTypeResponseFromJSONTyped(json, false);
}

export function AssetTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function AssetTypeResponseToJSON(json: any): AssetTypeResponse {
    return AssetTypeResponseToJSONTyped(json, false);
}

export function AssetTypeResponseToJSONTyped(value?: AssetTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

